export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Route/GProuteOptions.png?7de4fba0ed02918e67ef61257d4bfa87";